import {useEffect, useRef} from 'react'
import {MinimalVideoPlayer, VideoPlayer} from '@primer/react-brand/esm'

import {t} from '@github-ui/swp-core/lib/utils/localization'
import type {Asset} from '@github-ui/swp-core/schemas/contentful/contentTypes/asset'

type VideoHostedProps = {
  optionVideo: Asset
  optionPoster?: Asset
  autoplay?: boolean
  priority?: 'high'
}

export function VideoHosted({optionVideo, optionPoster, autoplay, priority}: VideoHostedProps) {
  const videoRef = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    const video = videoRef.current
    if (!video) return

    if (video.readyState >= 1) {
      video.dispatchEvent(new Event('loadedmetadata'))
    }
  }, [])

  const title = optionVideo.fields.description ?? 'Video'

  return (
    <>
      {priority === 'high' && optionPoster && (
        <link rel="preload" as="image" href={optionPoster.fields.file.url} fetchPriority="high" />
      )}

      {autoplay ? (
        <MinimalVideoPlayer
          internalAccessibleLabels={{
            play: t('Play video'),
            pause: t('Pause video'),
          }}
          poster={optionPoster?.fields.file.url}
          title={title}
        >
          <source src={optionVideo.fields.file.url} type="video/mp4" />
        </MinimalVideoPlayer>
      ) : (
        <VideoPlayer
          visuallyHiddenTitle
          ref={videoRef}
          title={title}
          poster={optionPoster?.fields.file.url}
          showSeekControl
          showCCButton
          showMuteButton
          showVolumeControl
          showFullScreenButton
          showBranding={false}
        >
          <VideoPlayer.Source src={optionVideo.fields.file.url} type="video/mp4" />
        </VideoPlayer>
      )}
    </>
  )
}
